package tools

import kotlinx.datetime.LocalDate
import org.ssoft.common.tools.nowDate
import org.ssoft.common.tools.nowDuration
import kotlin.math.roundToInt
import kotlin.time.Duration
import kotlin.time.Duration.Companion.days

class ImpressionCalculator(
    containsCommercial: Boolean,
    containsNonCommercial: Boolean,
    private val real: Long,
    targetMax: Long,
    start: LocalDate,
    end: LocalDate
) {
    private val target: Double = (targetMax.toDouble() * 0.95)

    private val now: LocalDate = kotlin.time.Clock.nowDate()
    private val nowDuration: Duration = kotlin.time.Clock.nowDuration()

//    private val finalEnd = end.plus(DatePeriod(days = 1))

    interface Nice {
        val all: String
        val com: String
        val ncom: String

    }

    val progress = when {
        now < start -> 0F
        now > end -> 1F
        else -> {
            val startDays = start.toEpochDays().days

            val endDur = ((end.toEpochDays().days + 1.days) - startDays)
            val nowDur = (nowDuration - startDays)

            runCatching {
                (nowDur.inWholeHours.toFloat() / endDur.inWholeHours.toFloat())
                    .takeIf { !it.isNaN() }
                    ?: 1F
            }.getOrNull() ?: 0F

        }
    }.coerceIn(0F, 1F)

    val pctCurrent = kotlin.runCatching {
        if (real > 0 && target > 0) real.toFloat() / target.toFloat()
        else 0F
    }.getOrNull() ?: 0F

    val pctCommercial = when {
        !containsCommercial -> 0F
        pctCurrent > progress && containsNonCommercial -> progress
        else -> pctCurrent
    }

    val pctNonCommercial = when {
        !containsCommercial -> pctCurrent
        containsNonCommercial && pctCurrent > progress -> pctCurrent - pctCommercial
        else -> 0F
    }

    val countCurrent =
        real.toInt()

    val countCommercial = when {
        !containsCommercial -> 0
        containsNonCommercial -> {
            runCatching {
                (target.toFloat() * pctCommercial)
                    .takeIf { !it.isNaN() }
                    ?.roundToInt()
                    ?.takeIf { it < real }
                    ?: error("bad value")
            }.getOrNull() ?: real.toInt()
        }

        else -> real.toInt()
    }

    val countNonCommercial = when {
        !containsCommercial -> real.toInt()
        containsNonCommercial && countCurrent > countCommercial -> {
            countCurrent - countCommercial
        }

        else -> 0
    }

    val counter = object : Nice {
        override val all: String
            get() = "${countCurrent}x"
        override val com: String
            get() = "${countCommercial}x"
        override val ncom: String
            get() = "${countNonCommercial}x"
    }

    val percentage = object : Nice {
        override val all: String
            get() = "${(pctCurrent * 100F).roundToInt()}%"
        override val com: String
            get() = "${(pctCommercial * 100F).roundToInt()}%"
        override val ncom: String
            get() = "${(pctNonCommercial * 100F).roundToInt()}%"
    }
}
